import { CustomSelectFieldProps, SelectField } from 'components/form'

export interface AnoSelectModel {
  id: ID
  nome: string
}

export const AnoSelectField = (props: CustomSelectFieldProps<AnoSelectModel>) => {
  return <SelectField<AnoSelectModel> items={items} itemToString={itemToString} {...props} />
}

const itemToString = (item: AnoSelectModel) => (item ? item.nome : '')

const getAnos = (): AnoSelectModel[] => {
  const anoAtual = new Date().getFullYear()

  return Array.from({ length: 100 }, (_, index) => ({
    id: index + 1,
    nome: String(anoAtual - index),
  }))
}
const items = getAnos()
